export interface TarifInterface {
  id?: number;
  tarifheure?: string;
  tarifacte?: string;
  tarifformation?: any;
  tarifheuredimanche?: any;
  tarifformationdimanche?: any;
  tarifactedimanche?: any;
  date_debut?: any;
  date_fin?: any;
  article_id?: number;
  created_at?: any;
  updated_at?: any;
  date_suppression?: any;
  saisie_manager_count?: number;
  article?: Article;
  parent_id?: number;
}

interface Article {
  id: number;
  actif: number;
  libelle: string;
  desactive_date: Date;
  idOperationIrm: any;
  idSocieteFacturation: any;
  activite_id: any;
  type_id: any;
  piv_oper_socifact_codes_id: number;
  code_article_id: number;
  devise_id: number;
  date_suppression: any;
  created_at: any;
  updated_at: any;
  code_article: CodeArticle;
  pivot_pays_bu: PivotPaysBU;
  devise: Devise;
  piv_oper_soc_code: PivOperSocCode;
}

interface CodeArticle {
  id: number;
  libelle: string;
  code_article_sage_id: any;
  created_at: string;
  updated_at: string;
  date_suppression: any;
}

interface PivotPaysBU {
  id: number,
  pays_id: number,
  bu_id: number,
  date_suppression: null,
  business_unit: {
    id: number,
    libelle: string
  },
  pays: {
    id: number,
    libelle: string
  }
}

interface Bu {
  id: number;
  libelle: string;
  created_at: string;
  updated_at: string;
  date_suppression: any;
}

interface Client {
  id: number;
  libelle: string;
  created_at: string;
  updated_at: string;
  date_suppression: any;
}

interface Pays {
  id: number;
  libelle: string;
  created_at: string;
  updated_at: any;
  date_suppression: any;
}

interface Devise {
  id: number;
  monnaie: string;
  symbole: string;
  code_iso: string;
  created_at: any;
  updated_at: any;
}

interface PivOperSocCode {
  id: number;
  operation_id: number;
  piv_socifact_code_id: number;
  operation: Operation;
  piv_societe_fact_code: PivSocieteFactCode;
}

interface Operation {
  id: number;
  libelle: string;
  clients_id: number;
  date_suppression: any;
  client: {
    id: number;
    libelle: string;
  }
}

interface PivSocieteFactCode {
  id: number;
  code_gesco_id: number;
  societe_facturation_id: number;
  societe_facturation: SocieteFacturation;
  code_gesco: CodeGesco;
}

interface SocieteFacturation {
  id: number;
  libelle: string;
  activite: any;
  forme_juridique: any;
  capital: any;
  adresse: string;
  code_postal: any;
  ville: any;
  registre_commerce: any;
  identifiant_fiscal: any;
  pays_id: number;
  code: string;
  created_at: any;
  updated_at: any;
  date_suppression: any;
}

interface CodeGesco {
  id: number;
  libelle: string;
  code_gesco_sage_id: any;
  created_at: string;
  updated_at: string;
  date_suppression: any;
}

export interface AssociationInterface {
  id: number;
  created_at: string;
  updated_at: string;
  pays_id: number;
  bu_id: number;
  clients_id: number;
  date_suppression: any;
  pays: Pays;
  bu: Bu;
  client: Client;
}

export const tableColumnTittlesTarif = [
  {
    id: 1,
    tittle: "Pays De Production",
    property: "paysLibelle",
    toSort: true
  },
  {
    id: 2,
    tittle: "Bu",
    property: "busLibelle",
    toSort: true
  },
  {
    id: 3,
    tittle: "Client",
    property: "clientLibelle",
    toSort: true
  },
  {
    id: 4,
    tittle: "Operation",
    property: "operationLibelle",
    toSort: true
  },

  {
    id: 5,
    tittle: "Societe Facturation",
    property: "societe_facturations.libelle",
    toSort: true
  },
  {
    id: 6,
    tittle: "Code gesco",
    property: "code_gescos.libelleCodeGesco",
    toSort: true
  },
  {
    id: 7,
    tittle: "Code Article",
    property: "codeArticleLibelle",
    toSort: false
  },
  {
    id: 8,
    tittle: "Désignation article",
    property: "articles.libelle",
    toSort: true
  },
  {
    id: 9,
    tittle: "Date Debut",
    property: "date_debut",
    toSort: true
  },

  {
    id: 10,
    tittle: "Date Fin",
    property: "date_fin",
    toSort: true
  },

  {
    id: 11,
    tittle: "Tarif Heure",
    property: "tarifheure",
    toSort: true
  },

  {
    id: 12,
    tittle: "Tarif Acte",
    property: "tarifacte",
    toSort: true
  }
];
